/*
 * cart-remove-confirm-trautis.js  —  /cart-Seite UND Cart-Drawer
 *
 * Ersetzt das Mülleimer-Icon: Stepper-Minus bei Menge 1 (oder direkt 0 eingetippt)
 * öffnet einen kurzen Bestätigungs-Dialog; erst „Entfernen" löscht die Position.
 * „Abbrechen" lässt die Menge auf 1.
 *
 * Technik: Das <cart-remove-button> bleibt im DOM (per CSS nur visuell versteckt) und
 * dient als Auslöser — bei Bestätigung klicken wir es programmatisch, sodass die Löschung
 * exakt über Dawns bestehenden Pfad läuft (CartItems.updateQuantity(index, 0) → 'clear').
 * Der Minus-Klick wird in der CAPTURE-Phase abgefangen, also VOR Dawns QuantityInput-
 * Handler (Bubble) — dadurch findet kein stepDown/change statt, der Input bleibt bei 1.
 *
 * Re-Render: Die /cart-Seite ersetzt nur `.js-contents` (Wrapper bleibt), ABER der Drawer
 * re-rendert via CartDrawerItems das ganze `.drawer__inner` und zerstört dabei das
 * <cart-drawer-items>. Darum hängen die Listener am `document` (Capture) statt an den Roots
 * — `document` überlebt jeden Re-Render; `inCartRoot()` scopt sie auf /cart + Drawer.
 */
(function () {
  'use strict';

  // Idempotenz: Skript wird global (Drawer) UND von /cart geladen — nur einmal initialisieren.
  if (window.__tCartRemoveConfirmInit) return;

  var roots = document.querySelectorAll('cart-items.t-cart, cart-drawer-items');
  if (!roots.length) return;
  window.__tCartRemoveConfirmInit = true;

  // --- Bestätigungs-Dialog (einmalig gebaut, wiederverwendet) ----------------
  var modal, nameEl, okBtn, cancelBtn, lastFocus, pendingRemoveBtn;

  function buildModal() {
    modal = document.createElement('div');
    modal.className = 't-confirm';
    modal.hidden = true;
    modal.innerHTML =
      '<div class="t-confirm__overlay" data-confirm-cancel></div>' +
      '<div class="t-confirm__dialog" role="dialog" aria-modal="true" aria-labelledby="t-confirm-title" aria-describedby="t-confirm-desc">' +
        '<h2 class="t-confirm__title" id="t-confirm-title">Artikel entfernen?</h2>' +
        '<p class="t-confirm__desc" id="t-confirm-desc"><b data-confirm-name></b> wird aus dem Warenkorb entfernt.</p>' +
        '<div class="t-confirm__actions">' +
          '<button type="button" class="t-confirm__btn t-confirm__btn--ghost" data-confirm-cancel>Abbrechen</button>' +
          '<button type="button" class="t-confirm__btn t-confirm__btn--danger" data-confirm-ok>Entfernen</button>' +
        '</div>' +
      '</div>';
    document.body.appendChild(modal);

    nameEl = modal.querySelector('[data-confirm-name]');
    okBtn = modal.querySelector('[data-confirm-ok]');
    cancelBtn = modal.querySelector('[data-confirm-cancel]');

    modal.addEventListener('click', function (e) {
      if (e.target.hasAttribute('data-confirm-cancel')) close(true);
    });
    okBtn.addEventListener('click', function () {
      var btn = pendingRemoveBtn;
      close(false);
      if (btn) btn.click();
    });
    modal.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') {
        e.preventDefault();
        close(true);
      } else if (e.key === 'Tab') {
        // Mini-Focus-Trap zwischen den zwei Buttons.
        var order = [cancelBtn, okBtn];
        var i = order.indexOf(document.activeElement);
        e.preventDefault();
        order[e.shiftKey ? (i <= 0 ? order.length - 1 : i - 1) : (i + 1) % order.length].focus();
      }
    });
  }

  function open(removeBtn, title) {
    if (!modal) buildModal();
    pendingRemoveBtn = removeBtn;
    nameEl.textContent = title || 'Dieser Artikel';
    lastFocus = document.activeElement;
    modal.hidden = false;
    document.documentElement.style.overflow = 'hidden';
    cancelBtn.focus();
  }

  function close(restoreFocus) {
    if (!modal) return;
    modal.hidden = true;
    document.documentElement.style.overflow = '';
    pendingRemoveBtn = null;
    if (restoreFocus && lastFocus && document.contains(lastFocus)) lastFocus.focus();
    lastFocus = null;
  }

  // --- Zeilen-Teile finden ---------------------------------------------------
  function rowParts(el) {
    var row = el.closest && el.closest('.cart-item');
    if (!row) return null;
    var name = row.querySelector('.cart-item__name');
    return {
      input: row.querySelector('.cart-quantity input, input.quantity__input'),
      removeBtn: row.querySelector('cart-remove-button'),
      title: name ? name.textContent.trim() : ''
    };
  }

  // Listener am DOCUMENT (Capture-Phase), NICHT an den Roots: Der Drawer re-rendert per
  // CartDrawerItems das KOMPLETTE `.drawer__inner` — dabei wird das <cart-drawer-items>
  // (samt daran gehängter Listener) zerstört und neu gebaut. Root-Listener wären nach der
  // ersten Mengenänderung tot (Minus täte nichts, Enter spränge zum Checkout). `document`
  // überlebt jeden Re-Render; `inCartRoot()` scopt die Treffer auf /cart + Drawer.
  function inCartRoot(el) {
    return !!(el && el.closest && el.closest('cart-items.t-cart, cart-drawer-items'));
  }

  // --- Minus bei Menge 1 abfangen (Capture → vor Dawns Bubble-Handler) -------
  document.addEventListener('click', function (e) {
    var minus = e.target.closest && e.target.closest(".quantity__button[name='minus']");
    if (!minus || !inCartRoot(minus)) return;
    var p = rowParts(minus);
    if (!p || !p.input || !p.removeBtn) return;
    if (parseInt(p.input.value, 10) <= 1) {
      e.preventDefault();
      e.stopImmediatePropagation();
      open(p.removeBtn, p.title);
    }
  }, true);

  // --- Direkt 0 (oder negativ) eingetippt: ebenfalls bestätigen --------------
  document.addEventListener('change', function (e) {
    var input = e.target;
    if (!input.classList || !input.classList.contains('quantity__input') || !inCartRoot(input)) return;
    var v = parseInt(input.value, 10);
    if (isNaN(v) || v > 0) return; // nur explizite 0/negativ; Leeres überlässt Dawn
    e.stopImmediatePropagation();
    input.value = input.getAttribute('value') || '1'; // zurücksetzen, bis bestätigt
    var p = rowParts(input);
    if (p && p.removeBtn) open(p.removeBtn, p.title);
  }, true);

  // --- Enter im Mengenfeld NICHT als Form-Submit (→ Checkout) werten ----------
  // Das <input> liegt im Cart-(Drawer-)Form, dessen einziger Submit-Button der Checkout
  // ist. Ohne dies springt Enter direkt zum Checkout statt die Menge zu aktualisieren.
  // blur() committet den Wert → löst 'change' aus (0 → Dialog oben, >0 → Dawns Update).
  document.addEventListener('keydown', function (e) {
    if (e.key !== 'Enter') return;
    var input = e.target;
    if (!input.classList || !input.classList.contains('quantity__input') || !inCartRoot(input)) return;
    e.preventDefault();
    input.blur();
  }, true);

  // --- Titel-Zähler „Dein Warenkorb (n)" synchron halten ---------------------
  // Der Zähler steht im .t-cart__head, also AUSSERHALB der von cart.js neu gerenderten
  // Bereiche (.js-contents / .js-contents-footer / cart-icon-bubble) und friert sonst
  // bei Hinzufügen/Entfernen ein. cartUpdate liefert die frische item_count.
  if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
    var countEl = document.querySelector('.t-cart__count');
    subscribe(PUB_SUB_EVENTS.cartUpdate, function (event) {
      var n = event && event.cartData ? event.cartData.item_count : undefined;
      if (typeof n !== 'number') return;
      if (!countEl) countEl = document.querySelector('.t-cart__count');
      if (!countEl) return;
      countEl.textContent = '(' + n + ')';
      countEl.hidden = n === 0;
    });
  }
})();
